export const NAME = 'users'
export const LABEL = 'Users'
export const PATH = `/${NAME}/`

export const FORM = 'Users'

export const PROFILE_PATH = `/profile/`
export const PROFILE_LABEL = 'Profile of '



// WEBPACK FOOTER //
// ./src/users/constants.js